import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import SortIcon from '@material-ui/icons/Sort'
import ListIcon from '@material-ui/icons/List'
import ConsoItemComponent from './ConsoItemComponent'
import {
  MODAL_CLIENT_CONSO_TRANSACTION,
  MODAL_CLIENT_SELECTION_PRODUCTS
} from 'redux/modules/modals'
import Grid from '@material-ui/core/Grid'
import _ from 'lodash'
const styles = theme => ({
  container: {
    height: 'calc(100%)'
  },
  scrollContainer: {
    overflow: 'auto',
    height: 'calc(100% - 128px)'
  },
  flex: {
    flex: 1
  },
  totalResume: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: 5
  },
  rightButton: {
    width: '36px !important',
    height: '36px !important'
  },
  iconButton: {
    color: 'white'
  },
  smallIcon: {
    width: 36,
    height: 36,
    color: 'white'
  },
  small: {
    width: 50,
    height: 50,
    padding: 5
  },
  price: {
    margin: '20px',
    color: 'white',
    lineHeight: '50px'
  },
  fullWidth: {
    height: '100%',
    width: '100%',
    maxWidth: 'none'
  }
})

export default withStyles(styles)(
  class SideBarConsosComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      addModal: PropTypes.bool,
      showTime: PropTypes.bool,
      validate: PropTypes.bool,
      transaction: PropTypes.object,
      products: PropTypes.array.isRequired,
      addConso: PropTypes.func.isRequired,
      removeConso: PropTypes.func.isRequired,
      changeReduc: PropTypes.func.isRequired,
      showModal: PropTypes.func
    }

    static defaultProps = {
      grouped: true,
      validate: false,
      showTime: false,
      addModal: false,
      isTotalActive: false,
      isTotalValidate: false,
      isValidateModalEnabled: false,
      validateDialogContent: null,
      consos: []
    }
    lastDeletedProduct
    state = {
      grouped: true
    }
    handleValidateClick = e => {
      if (!this.props.products || this.props.products.length === 0) return
      this.props.showModal(MODAL_CLIENT_SELECTION_PRODUCTS, this.props.products)
    }
    handleAddOneConso = product => {
      const newProduct = { ...product }
      delete newProduct.counter
      this.props.addConso(this.props.transaction, newProduct)
    }
    handleRemoveOneConso = product => {
      if (
        this.props.transaction &&
        this.lastDeletedProduct &&
        _.isEqual(this.lastDeletedProduct, product)
      ) {
        return
      }
      const newProduct = { ...product }
      delete newProduct.counter
      this.lastDeletedKey = newProduct.key
      this.props.removeConso(this.props.transaction, newProduct)
    }
    handleAddConsosModalClick = () => {
      if (!this.props.transaction) return
      this.props.showModal(
        MODAL_CLIENT_CONSO_TRANSACTION,
        this.props.transaction
      )
    }
    handleSortClicked = () => {
      this.setState({ grouped: !this.state.grouped })
    }
    calculateTotal = () => {
      let total = 0
      this.props.products.map((p, index) => {
        total += p.reduc === void 0 ? Number(p.price) : Number(p.price)
        return null
      })
      return total
    }
    groupedSort = () => {
      let consosTab = []
      this.props.products.filter(p => !p.deletedBy).map((item, index) => {
        let i = consosTab.findIndex(e => {
          return e.product_id === item.product_id && e.price === item.price
        })
        let drink = { ...item }
        if (i === -1) {
          drink.counter = 1
          consosTab.push(drink)
        } else {
          if (
            consosTab[i].id_sale_product_detail &&
            !drink.id_sale_product_detail
          ) {
            consosTab[i] = { ...consosTab[i], ...drink }
          }

          consosTab[i].counter++
        }
        return null
      })
      consosTab = _.orderBy(consosTab, ['name', 'price'], ['asc', 'desc'])
      return consosTab
    }

    unGroupedSort = () => {
      let consosTab = [...this.props.products]
      return consosTab.filter(p => !p.deletedBy).reverse()
    }
    render() {
      const { classes, addModal, validate, transaction } = this.props
      let consosTab = this.state.grouped
        ? this.groupedSort()
        : this.unGroupedSort()
      const total = this.calculateTotal()
      return (
        <Grid
          className={classes.container}
          container
          direction="column"
          wrap="nowrap"
          justify="space-between"
          alignItems="stretch"
          spacing={0}>
          <AppBar
            style={{ borderRadius: 5, marginBottom: '10px' }}
            position="static">
            <Toolbar style={{ color: 'white' }}>
              <Typography
                variant="title"
                color="inherit"
                className={classes.flex}>
                {transaction ? 'Produits' : 'Produits sélectionnés'}
              </Typography>
              {this.renderRightIcons(classes, addModal, this.state.grouped)}
            </Toolbar>
          </AppBar>
          <Grid
            className={classes.scrollContainer}
            item
            container
            spacing={16}
            direction="row"
            alignContent="flex-start"
            alignItems="flex-start"
            justify="center">
            {consosTab.map((item, index) => {
              return (
                <ConsoItemComponent
                  key={item.key}
                  grouped={this.state.grouped}
                  showTime={this.props.showTime}
                  product={item}
                  transaction={this.props.transaction}
                  addConso={this.handleAddOneConso}
                  removeConso={this.handleRemoveOneConso}
                  changeReduc={this.props.changeReduc}
                />
              )
            })}
          </Grid>
          {!validate &&
            consosTab.length > 0 &&
            this.renderTotalResume(classes, total, consosTab)}
          {validate &&
            consosTab.length > 0 &&
            this.renderTotal(classes, total, consosTab)}
        </Grid>
      )
    }
    renderRightIcons(classes, addModal, grouped) {
      const { transaction } = this.props
      return (
        <div>
          <IconButton
            className={classes.iconButton}
            onClick={this.handleSortClicked}>
            {grouped ? (
              <ListIcon style={{ width: 36, height: 36 }} />
            ) : (
              <SortIcon color="inherit" />
            )}
          </IconButton>
          {addModal && (
            <IconButton
              className={classes.iconButton}
              disabled={
                transaction &&
                !transaction.sale_id &&
                !((transaction || {}).pool || {}).id_sale_product_detail
              }
              onClick={this.handleAddConsosModalClick}>
              <AddCircleIcon
                style={{ width: 36, height: 36 }}
                color="inherit"
              />
            </IconButton>
          )}
        </div>
      )
    }
    renderTotalResume(classes, total, products) {
      return (
        <AppBar
          style={{ borderRadius: 5, marginTop: 8 }}
          elevation={5}
          className={classes.totalResume}
          position="static">
          <Toolbar>
            <Typography
              variant="title"
              color="inherit"
              className={classes.flex}>
              Total : {total.toFixed(2) + ' €'}
            </Typography>
          </Toolbar>
        </AppBar>
      )
    }
    renderTotal(classes, total, products) {
      return (
        <Grid item>
          <AppBar
            elevation={5}
            style={{ borderRadius: 5, marginTop: 8 }}
            position="static">
            <Toolbar>
              <Typography
                variant="title"
                color="inherit"
                className={classes.flex}>
                Total : {total.toFixed(2) + ' €'}
              </Typography>
              <Button
                onClick={this.handleValidateClick}
                color="secondary"
                variant="raised">
                Valider
              </Button>
            </Toolbar>
          </AppBar>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/SideBarConsosComponent/index.js